// ##############################
// // // Map component style
// #############################

import {
  defaultFont,
  primaryColor,
  primaryBoxShadow,
  infoColor,
  infoBoxShadow,
  successColor,
  successBoxShadow,
  warningColor,
  warningBoxShadow,
  dangerColor,
  dangerBoxShadow,
  roseColor,
  roseBoxShadow
} from "assets/jss/material-kit-pro-react.jsx";

import buttonGroup from "assets/jss/material-kit-pro-react/buttonGroupStyle.jsx";
// import customDropdown from "assets/jss/material-kit-pro-react/components/customDropdownStyle.jsx";

import buttonStyle from "assets/jss/material-kit-pro-react/components/buttonStyle.jsx";


const mapStyle = theme => ({
  ...buttonStyle,
  ...buttonGroup,
  popperClose: {
    pointerEvents: "none",
    display: "none !important"
  },
  pooperNav: {
    [theme.breakpoints.down("sm")]: {
      position: "static !important",
      left: "unset !important",
      top: "unset !important",
      transform: "none !important",
      willChange: "none !important",
      "& > div": {
        boxShadow: "none !important",
        marginLeft: "1.5rem",
        marginRight: "1.5rem",
        transition: "none !important",
        marginTop: "0px !important",
        marginBottom: "5px !important",
        padding: "0px !important"
      }
    }
  },
  pooperResponsive: {
    zIndex: "1200",
    [theme.breakpoints.down("sm")]: {
      zIndex: "1640",
      position: "static",
      float: "none",
      width: "auto",
      marginTop: "0",
      backgroundColor: "transparent",
      border: "0",
      boxShadow: "none",
      color: "black"
    }
  },

  popperLayerSelector:{
    maxWidth: "300px"
  },
  tabsLayerInfoLegend: {
    width: "33%",
    minWidth: "33%",
    maxWidth: "50%"
  },


  dropdownHeader: {
    display: "block",
    padding: "0.1875rem 1.25rem",
    fontSize: "0.75rem",
    lineHeight: "1.428571",
    color: "#777",
    whiteSpace: "nowrap",
    fontWeight: "inherit",
    marginTop: "10px",
    "&:hover,&:focus": {
      backgroundColor: "transparent",
      cursor: "auto"
    }
  },

  dropdownItem: {
    ...defaultFont,
    fontSize: "13px",
    padding: "8px 14px",
    margin: "0 5px",
    borderRadius: "2px",
    position: "relative",
    transition: "all 150ms linear",
    display: "block",
    clear: "both",
    fontWeight: "400",
    height: "100%",
    color: "#333",
    whiteSpace: "nowrap"
  },

  primaryHover: {
    "&:hover": {
      backgroundColor: primaryColor,
      color: "#FFFFFF",
      ...primaryBoxShadow
    }
  },
  infoHover: {
    "&:hover": {
      backgroundColor: infoColor,
      color: "#FFFFFF",
      ...infoBoxShadow
    }
  },
  successHover: {
    "&:hover": {
      backgroundColor: successColor,
      color: "#FFFFFF",
      ...successBoxShadow
    }
  },
  warningHover: {
    "&:hover": {
      backgroundColor: warningColor,
      color: "#FFFFFF",
      ...warningBoxShadow
    }
  },
  dangerHover: {
    "&:hover": {
      backgroundColor: dangerColor,
      color: "#FFFFFF",
      ...dangerBoxShadow
    }
  },
  roseHover: {
    "&:hover": {
      backgroundColor: roseColor,
      color: "#FFFFFF",
      ...roseBoxShadow
    }
  },


  caret: {
    transition: "all 150ms ease-in",
    display: "inline-block",
    width: "0",
    height: "0",
    marginLeft: "4px",
    verticalAlign: "middle",
    borderTop: "4px solid",
    borderRight: "4px solid transparent",
    borderLeft: "4px solid transparent"
  },
  caretActive: {
    transform: "rotate(180deg)"
  },
  caretDropup: {
    transform: "rotate(180deg)"
  },

  dropdownIcons: {
    width: "24px",
    height: "24px",
    marginRight: "14px",
    opacity: "0.5",
    marginTop: "-4px",
    top: "1px",
    verticalAlign: "middle",
    fontSize: "24px",
    position: "relative"
  },

  topControl: {
    padding: "0px 20px"
  },

  buttonGroup: {
    whiteSpace: "nowrap",
    maxWidth: "100%"
  },
  firstButton: {
    borderTopRightRadius: "0",
    borderBottomRightRadius: "0",
    margin: ".3125rem 0px .3125rem 1px",
    // maxWidth: "300px"
    maxWidth: "85%"
  },
  middleButton: {
    borderRadius: "0",
    margin: ".3125rem 0px .3125rem 0px"
  },
  lastButton: {
    borderTopLeftRadius: "0",
    borderBottomLeftRadius: "0",
    margin: ".3125rem 1px .3125rem 0px"
  },


  mainButton: {
    // width: "unset !important",
    // minWidth: "300px",
    maxWidth: "85%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  },
  settingsButton: {
    color: "#FFFFFF",
    padding: "12px 10px 12px 10px",
    width: "30px",
    maxWidth: "30px",

  },
  smallButton: {
    paddingTop: "20px",
    paddingBottom: "20px",
    height: "30px",
    maxWidth: "30px"
  },
  smallButtonIcon: {
    paddingTop: "1px",
  },
  mainMap: {
    position: "relative",
    // marginTop: "0px",
    width: "100%",
    height: "100%",
    zIndex: "0",
  },
  secondaryActionButton: {
    padding: "6px",
    borderRadius: "2px",
    backgroundColor: "rgba(255,255,255,0.8)",
    "&:hover": {
      backgroundColor: primaryColor,
      color: "#FFFFFF",
      ...primaryBoxShadow
    }
  },
  secondaryActionButtonIcon: {
    marginRight: "0px"
  },

  menu: {
    zIndex: "90",
    // background: "rgba(138, 195, 95, 0.5)"
  },
  topMenu: {
    position: "relative",
    top: "0px",
    left: "0px",
    width: "100%"
  },
  sideContent: {
    position: "absolute",
    top: "0px",
    right: "0px",
    width: "100%",
    padding: "10px",
    font: defaultFont,
    fontSize: "12px",
    color: "#FFF",
    backgroundColor: "rgba(50, 50, 50, 0.8)",
    overflowY: "auto",
    minWidth: "100px",
    maxHeight: "100%",
  },
  sideContentRight: {
    right: "0px",
    padding: "10px",
  },
  sideContentLeft: {
    left: "0px",
    // maxWidth: "240px",
    padding: "0px 10px",

  },
  bottomMenu: {
    position: "absolute",
    left: "0px",
    right: "0px",
    bottom: "0px",
    padding: "0px",
    marginRight: "15px",
    zIndex: "2"
  },
  cardBodyRefine: {
    paddingLeft: "15px",
    paddingRight: "15px"
  },
  configpanel: {
    padding: "30px"
  },
  noSelect: {
    MozUserSelect: 'none',
    WebkitUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none',
    oUserSelect: 'none',
    unselectable: "on",
    onselectstart: "return false;" ,
    onmousedown: "return false"
  },

  dimTool: {
    font: defaultFont,
    fontSize: "12px",
    color: "#FFF",
    backgroundColor: "rgba(50, 50, 50, 0.8)"
  },

  /* Map Scale */

  mapScale: {
    font: defaultFont,
    fontSize: "12px",
    color: "#FFFFFF",
    lineHeight: "1em",
    padding: "5px 10px",
    textAlign: "right",
  },

  mapScaleInput: {
    width: "80px"
  },

  mapScaleLabel: {
    cursor: "text"
  },

  /* Show Coords */

  showCoords: {
    padding: "3px 10px",
    textAlign: "right"
  },

  /* Swipe Tool */

  swipeToolContainer: {
    width: "100%",
    height: "35px",
    padding: "3px 20px 3px 40px"
  },

  swipeSlider: {
    marginTop: "15px"
  },

  swipeTool: {
    width: "100%",
    zIndex: 20
  },

  /* Swipe Bar */

  swipeContainer: {
    position: "absolute",
    height: "100%",
    width: "16px",
    zIndex: "1",
    top: "0px"
  },

  swipeBar: {
    backgroundColor: "rgba(127, 193, 66, 0.498039)",
    width: "16px",
    position: "relative",
    height: "100%",
    left: "0px",
    borderLeft: "1px solid rgb(255, 255, 255)",
    borderRight: "1px solid white",
    zIndex: "1"
  },

  /* Time Slider */

  timeSlider: {
    marginTop: "30px"
  },

  /* Simple Map */
  simpleMap: {
    zIndex: 0,
    height: "550px",
    maxHeight: "600px"
  },
  simpleMapToolTip: {
    position: "absolute",
    display: "block",
    color: "#fff",
    lineheight: "1.5em",
    background: "#555",
    border: "none",
    borderrdius: "30px",
    padding: "5px 10px",
    zIndex: "100",
    fontFamily: defaultFont,
    fontSize: "smaller",
  },
  featureInfoCloseContainer: {
    float: "right",
    display: "inline-block",
    padding: "0px"
  },
  featureInfoCloseButton: {
    color: "#FFF",
    padding: "5px",
  },
  featureInfoCloseIcon: {
    fontSize: "14px"
  },

  /* Legend */
  legend: {
    padding: "10px",
    overflowY: "auto"
  },
  legendEntry: {
    width: "100%",
    padding: "5px"
  },
  legendBox: {
    color: "#FFF",
    display: "inline-block",
    width: "15px",
    height: "15px",
    border: "1px solid #ccc",
    marginTop: "3px",
    marginRight: "10px",
    float: "left"
  },
  legendText: {
    marginLeft: "25px",
    color: "#FFF",
    textAlign: "left"
  },
  legendCode: {
    color: "#FFF"
  },
  controlLayout: {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: "1",
    left: "1",
    margin: "0px"
  },
  alertTitle: {
    fontSize: "2.25rem",
    fontWeight: "300"
  },
  alertInput: {
    fontSize: "14px",
    height: "36px",
  }

});

export default mapStyle;
